import React, { useEffect, useRef } from "react";
import { Box, Typography, Stack } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { DateFormater, formatAmount } from "../../../HelperFunctions/HelperFunctions";
import { useLoaderData } from "react-router-dom";
import dayjs from "dayjs";
import { enqueueSnackbar } from "notistack";





export const ChargeBackChart = ({
  chargeBacksLabelsData,
  selectedProfitCenter,
  selectedMerchantProvider,
  dateRange,
}) => {
  const FRONTEND_API_URL = process.env.REACT_APP_FRONTEND_API_URL

  const { headerCorporation, clientNameURL, clientName, authId, corpId, menuId, Previlage, merchatScreenPrevilage } = useLoaderData();
  const merchantProviderRef = useRef(selectedMerchantProvider);
  const selectedProfitCenterRef = useRef(selectedProfitCenter);
  const dateRangeRef = useRef(dateRange);

  useEffect(() => {
    merchantProviderRef.current = selectedMerchantProvider;
  }, [selectedMerchantProvider]);

  useEffect(() => {
    selectedProfitCenterRef.current = selectedProfitCenter;
  }, [selectedProfitCenter]);

  useEffect(() => {
    dateRangeRef.current = dateRange;
  }, [dateRange]);

  const handleSliceClick = (idx) => {

    if (!headerCorporation) {
      enqueueSnackbar("Please select the corporation to proceed further", { variant: "warning" });
      return;
    };

    if (!Previlage?.[0].Update) {
      enqueueSnackbar("You do not have sufficient privileges to perform this action", { variant: "warning" });
      return;
    }
    if (!merchatScreenPrevilage?.[0].Create) {
      enqueueSnackbar("You do not have sufficient privileges to perform this action", { variant: "warning" });
      return;
    }

    const label = chargeBacksLabelsData.labels[idx];

    const merchantID =
      typeof merchantProviderRef.current === "string" && merchantProviderRef.current.trim()
        ? merchantProviderRef.current.trim()
        : "0";
    const pcID =
      selectedProfitCenterRef.current?.ID !== "select"
        ? selectedProfitCenterRef.current?.ID || "0"
        : "0";

    const [from, to] = dateRangeRef.current || [];
    const fromDate = from ? dayjs(from).format("MM-DD-YYYY") : "";
    const toDate = to ? dayjs(to).format("MM-DD-YYYY") : "";

    const screentype = label || "Pending";

    const routetype = "chargebacks";

    const newUrl = `${FRONTEND_API_URL}/reconciliation/${clientName}/${authId}/${menuId}/${corpId}/${encodeURIComponent(merchantID)}/${encodeURIComponent(pcID)}/${fromDate}&${toDate}/${screentype}/${routetype}`;
    const message = {
      type: "chargebacks",
      url: newUrl,
    };

    window.parent.postMessage(message, `${clientNameURL}NimblePropertyMetroIndex.aspx?q=639092311520691233`);

  };


  const actualSeries = chargeBacksLabelsData.series;
  const percentageData = chargeBacksLabelsData.percentage;

  const displaySeries = actualSeries.map((val) => (val === 0 ? 1 : val));

  const options = {
    chart: {
      type: "donut",
      fontFamily: "Poppins",
      events: {
        dataPointSelection: (event, chartContext, config) => {
          const value = actualSeries[config.dataPointIndex];
          if (value === 0) return;
          if (event) {
            event.preventDefault();
            event.stopPropagation();
          }
          handleSliceClick(config.dataPointIndex);
        },
        dataPointMouseEnter: (event, chartContext, config) => {
          // chartContext.el.style.cursor = "pointer";
          const value = actualSeries[config.dataPointIndex];
          chartContext.el.style.cursor = value === 0 ? "default" : "pointer";
        },
        dataPointMouseLeave: (event, chartContext) => {
          chartContext.el.style.cursor = "default";
        },
      },
    },
    labels: chargeBacksLabelsData.labels,
    colors: actualSeries.map((val, idx) =>
      val === 0 ? "#e0e0e0" : ["#ffcf29", "#ff822d", "#03bb6f"][idx],
    ),
    legend: { show: false },
    dataLabels: { enabled: false },
    plotOptions: {
      pie: {
        donut: {
          size: "90%",
          labels: {
            show: true,
            name: {
              show: true,
            },
            value: {
              show: true,
            },
            total: {
              show: true,
              showAlways: true,
              label: "Total Chargebacks",
              fontSize: "12px",
              fontWeight: 400,
              color: "#333",
              formatter: function (w) {
                const total = actualSeries.reduce((a, b) => a + b, 0);
                return `$ ${formatAmount(total)}`;
              },
            },
          },
        },
      },
    },
    // tooltip: {
    //   y: {
    //     formatter: (_, { seriesIndex }) => {
    //       const val = actualSeries[seriesIndex];
    //       const percent = percentageData[seriesIndex];
    //       const label = w.globals.labels[seriesIndex];

    //   return `$ ${formatAmount(val)}\n${label} ${percent}%`;
    //       // return `$ ${formatAmount(val)} - ${percent}%`;
    //     },
    //   },
    // },
    tooltip: {
      custom: function ({ series, seriesIndex, w }) {
        const val = actualSeries[seriesIndex];
        const percent = percentageData[seriesIndex];
        const label = w?.globals?.labels[seriesIndex];

        //     return `
        //   <div style="padding:5px; font-family:Poppins">
        //     <div style="font-weight:500;">$ ${formatAmount(val)}</div>
        //     <div style="color:#666; font-size:12px;">
        //       ${label} ${percent}%
        //     </div>
        //   </div>
        // `;

        return `
              <div style="
                background:#5f6368;
                color:#fff;
                padding:4px 6px;
                border-radius:6px;
                font-family:Poppins;
              ">
                <div style="
                  font-size:12px;
                  font-weight:500;
                  line-height:1.2;
                  text-align:center;
                ">
                  $ ${formatAmount(val)}
                </div>
              <div style="
                  font-size:11px;
                  margin-top:2px;
                ">
                  <span style="opacity:0.7; font-size:9px">${label}</span>
                  <span style="opacity:1; margin-left:4px; font-weight:500; font-size:9px">
                    ${percent}%
                  </span>
                </div>
              </div>
            `;
      }
    }
  };

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      style={{
        width: "100%",
        height: "100%",
        marginTop: 10,
      }}
    >
      <ReactApexChart
        options={options}
        series={displaySeries}
        type="donut"
        height="100%"
        width="100%"
      />
    </Stack>
  );
};

export const PercentageBar = ({ left = 0, right = 0, date, selectedProfitCenter }) => {
  const FRONTEND_API_URL = process.env.REACT_APP_FRONTEND_API_URL


  const { headerCorporation, clientNameURL, clientName, authId, corpId, menuId, Previlage, merchatScreenPrevilage } = useLoaderData();

  const selectedProfitCenterRef = useRef(selectedProfitCenter);
  useEffect(() => {
    selectedProfitCenterRef.current = selectedProfitCenter;
  }, [selectedProfitCenter]);

  const pendingChargeBackBarClicked = () => {
    if (!headerCorporation) {
      enqueueSnackbar("Please select the corporation to proceed further", { variant: "warning" });
      return;
    };

    if (!Previlage?.[0].Update) {
      enqueueSnackbar("You do not have sufficient privileges to perform this action", { variant: "warning" });
      return;
    }
    if (!merchatScreenPrevilage?.[0].Create) {
      enqueueSnackbar("You do not have sufficient privileges to perform this action", { variant: "warning" });
      return;
    };

    const pcID =
      selectedProfitCenterRef.current?.ID !== "select"
        ? selectedProfitCenterRef.current?.ID || "0"
        : "0";

    const screentype = "Pending";

    const routetype = "chargebacks";

    const formateDate = date.replaceAll("/", "-");


    const newUrl = `${FRONTEND_API_URL}/reconciliation/${clientName}/${authId}/${menuId}/${corpId}/0/${encodeURIComponent(pcID)}/${formateDate}&${formateDate}/${screentype}/${routetype}`;
    const message = {
      type: "chargebacks",
      url: newUrl,
    };

    window.parent.postMessage(message, `${clientNameURL}NimblePropertyMetroIndex.aspx?q=639092311520691233`);


  }


  return (
    <>
      <Stack direction={"row"} justifyContent={"space-between"} pl={0.5} pr={0.5} >
        <Typography fontSize={9} fontWeight={500}>
          <span title={`${left}%`}>{left}%</span>
        </Typography>

        <Typography fontSize={9} fontWeight={500} sx={{ color: "black" }}>
          <span title={`${right}%`}>{right}%</span>
        </Typography>
      </Stack>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          height: 40,
          borderRadius: 2,
          overflow: "hidden",
          backgroundColor: "#eee",
          justifyContent: left + right === 0 ? "end" : null,
          alignItems: left + right === 0 ? "center" : null,
          cursor: left + right !== 0 ? "pointer" : null,
          // border: "1px solid red"
        }}
        onClick={() => {
          if (left + right !== 0) {
            pendingChargeBackBarClicked();
          }
        }}
      >
        {/* {left + right !== 0 ? ( */}
        <>
          <Box
            sx={{
              // flex: left,
              width: `${left}%`,
              backgroundColor: "#86e1e1",
              display: "flex",
              alignItems: "center",
              borderRadius: 2,
              justifyContent: "end",
              // p: 1
            }}
          >
            {/* <Typography fontSize={12}>
              <span title={`${left}%`}>{left}%</span>
            </Typography> */}
          </Box>

          <Box
            sx={{
              // flex: right,
              width: `${right}%`,

              backgroundColor: "#eee",
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              // p: 1
            }}
          >
            {/* <Typography fontSize={12} sx={{ color: "black" }}>
              <span title={`${right}%`}>{right}%</span>
            </Typography> */}

          </Box>
        </>


        {/* ) : (
          "0 %"
        )} */}
      </Box>
    </>


  );
};
